<template>
  <section id="home" class="relative min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 overflow-hidden">
    <div class="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23f59e0b%22%20fill-opacity%3D%220.08%22%3E%3Cpath%20d%3D%22M36%2034v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6%2034v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6%204V0H4v4H0v2h4v4h2V6h4V4H6z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E')]"></div>

    <div class="absolute top-1/4 -left-32 w-96 h-96 bg-amber-400/20 rounded-full blur-3xl animate-pulse-slow"></div>
    <div class="absolute bottom-1/4 -right-32 w-96 h-96 bg-orange-400/20 rounded-full blur-3xl animate-pulse-slow" style="animation-delay: 2s;"></div>
    <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-yellow-400/10 rounded-full blur-3xl"></div>

    <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
      <div class="grid lg:grid-cols-2 gap-16 items-center min-h-[calc(100vh-200px)]">
        <div>
          <div class="inline-flex items-center px-5 py-2.5 bg-amber-100 rounded-full mb-8">
            <Leaf :size="20" class="mr-2 text-amber-600" />
            <span class="text-sm font-semibold text-amber-700">天然健康 品质保证</span>
          </div>

          <h1 class="text-5xl sm:text-6xl lg:text-7xl font-bold font-display leading-tight mb-8">
            宁夏西明
            <span class="text-amber-600">食品有限公司</span>
          </h1>

          <p class="text-xl text-gray-600 mb-10 max-w-lg leading-relaxed">
            专业从事食用油脂研发、生产和销售，主营精炼牛油、鸡油等高品质食用油脂，为食品加工企业提供优质原料。
          </p>

          <div class="flex flex-col sm:flex-row gap-5 mb-16">
            <a href="#services" class="px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold rounded-full hover:opacity-90 transition-all duration-300 shadow-lg shadow-amber-500/30 flex items-center justify-center group">
              <span>了解产品</span>
              <ArrowRight :size="22" class="ml-3 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#contact" class="px-8 py-4 border-2 border-amber-500 text-amber-600 font-semibold rounded-full hover:bg-amber-50 transition-all duration-300 flex items-center justify-center group">
              <Phone :size="22" class="mr-3" />
              <span>联系我们</span>
            </a>
          </div>

          <div class="grid grid-cols-3 gap-8">
            <div class="text-center">
              <div class="text-4xl font-bold text-amber-600 mb-2">20+</div>
              <div class="text-sm text-gray-500">年行业经验</div>
            </div>
            <div class="text-center">
              <div class="text-4xl font-bold text-amber-600 mb-2">500+</div>
              <div class="text-sm text-gray-500">合作企业</div>
            </div>
            <div class="text-center">
              <div class="text-4xl font-bold text-amber-600 mb-2">99%</div>
              <div class="text-sm text-gray-500">产品合格率</div>
            </div>
          </div>
        </div>

        <div class="relative">
          <div class="relative rounded-3xl p-2 bg-white shadow-2xl animate-float">
            <img :src="heroImage"
                 alt="食用油脂产品" class="w-full rounded-2xl" />
          </div>

          <div class="absolute -bottom-8 -left-8 bg-white rounded-2xl p-5 shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-1">
            <div class="flex items-center gap-4">
              <div class="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                <Award :size="24" class="text-green-600" />
              </div>
              <div>
                <div class="text-lg font-bold text-gray-800">质量认证</div>
                <div class="text-sm text-gray-500">ISO9001认证</div>
              </div>
            </div>
          </div>

          <div class="absolute -top-6 -right-6 bg-white rounded-2xl p-5 shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-1">
            <div class="flex items-center gap-4">
              <div class="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center">
                <Truck :size="24" class="text-amber-600" />
              </div>
              <div>
                <div class="text-lg font-bold text-gray-800">全国配送</div>
                <div class="text-sm text-gray-500">冷链物流</div>
              </div>
            </div>
          </div>

          <div class="absolute -bottom-4 -right-4 w-32 h-32 bg-amber-400/20 rounded-full blur-2xl"></div>
        </div>
      </div>
    </div>

    <div class="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
      <a href="#about" class="text-amber-600 hover:text-amber-700 transition-colors">
        <ChevronDown :size="36" />
      </a>
    </div>
  </section>
</template>

<script setup>
import { Leaf, ArrowRight, Phone, Award, Truck, ChevronDown } from 'lucide-vue-next'
import heroImage from '@/assets/images/hero.jpg'
</script>
